import React, { FC, useContext, useEffect } from 'react';
import { useState } from "react";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import SpinPage from '../../components/UI/Spin/Spin';
import { useLocation } from 'react-router-dom';
import "./LoginForm.css";
import ReCAPTCHA from 'react-google-recaptcha';
import { SPECIAL_KEY } from "../../Utils/Secret"
import { NAME_HOST, NAME_SERVER } from "../../Utils/NAME_HOST"
import ErrorComponent from '../../components/UI/Error/ErrorComponent';
import '../RegForm/RegForm.css';
import { useNavigate } from "react-router-dom"
import vk from "../RegForm/vk.png"

import google from "../RegForm/google.png"
import Footer from "../../components/Footer/Footer";
import { fillTextPage } from "../../Utils/FillTextPage";
import BackButton from '../../components/UI/BackButton/BackButton';
import UserService from '../../service/UserService';
import Succses from '../../components/UI/Notification/Succses';
import { Spin } from 'antd';

function LoginForm() {
    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState("")
    const [login, setLogin] = useState("")
    const [error, setError] = useState("")
    const [statusErrorChange, setStatusErrorChange] = useState(false);
    const [stateForgot, setStatusForgot] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("")
    const [statusLoadRecoverBtn, setStatusLoadRecoverBtn] = useState(false);

    const [statePassword, setStatePassword] = useState(false);


    const { store } = useContext(Context)
    const [token_re, setToken_re] = useState("")

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const room_id = queryParams.get('room');
    useEffect(() => {
        fillTextPage("login", store)
    }, [])
    useEffect(() => {

        if (error.length > 0) {
            store.add_message(error, ErrorComponent)
        }
    }, [statusErrorChange]);
    useEffect(() => {
        if (store.isAuth) {
            if (store.user.login) {
                navigate("/")

            }

        }
    }, [store.isAuth])
    async function handleRecover(e) {

        if (email) {
            try {
                setStatusLoadRecoverBtn(true)

                const answer_from_response = await UserService.change_password({ method: "send", email });

                if (answer_from_response.data.err) {
                    store.add_message(answer_from_response.data.err, ErrorComponent)
                    setStatusLoadRecoverBtn(false)


                } else {
                    store.add_message("Ссылка с восстановлением отправлена на email", Succses);
                    setStatusForgot(false);
                    setStatusLoadRecoverBtn(false)

                }

            } catch (e) {
                store.add_message("error1", ErrorComponent)
                setStatusLoadRecoverBtn(false)




            }

            // Перенаправление на другую страницу
        }

    }
    async function handlerButtonLogin(e) {


        

        if ((email || login) && password) {
            try {

                const aswer_from_response = await store.login(email, password, SPECIAL_KEY); // Ожидание завершения функции
                if (aswer_from_response.err) {
                    store.add_message(aswer_from_response.err, ErrorComponent)

                } else {
                    if (room_id) {
                        window.location.replace(NAME_HOST + "/game/" + room_id)
                    } else {
                        navigate("/")
                    }

                }

            } catch (e) {
                store.add_message("error1", ErrorComponent)


            }

            // Перенаправление на другую страницу
        }
    }

    const changer = (value) => {
        setToken_re(value)
    }
    return (
        <>
            

                {store.isLoading ? (
                    <SpinPage />
                ) : (
                    <>

                        <div className="contentFormLogin">


                            <div className="login-box">
                                <span></span>
                                <span></span>
                                <span></span>


                                {!stateForgot ? (
                                    <form>
                                        <h2>{store.dataLang["enter_name_title"]}</h2>


                                        <input className="login_input" type="text" onChange={e => setEmail(e.target.value)}
                                            placeholder={store.dataLang["login_text1"]} />

                                        <div style={{ position: "relative" }}>
                                            <input className="password login_input" onChange={e => setPassword(e.target.value)}
                                                type={statePassword ? "text" : "password"} placeholder={store.dataLang["password_name"]} />
                                            <i style={{ top: "30px" }} class={`fa-solid ${statePassword ? "fa-eye-slash" : "fa-eye"} eye_password`} onClick={() => setStatePassword(prev => !prev)}></i>
                                        </div>



                                        {/*<ReCAPTCHA*/}
                                        {/*    sitekey="6LeROBooAAAAAFgL6IfH4WBR9gv6xmfBwL-ZYv7Q"*/}
                                        {/*    onChange={changer}*/}
                                        {/*/>*/}
                                        <div onClick={() => setStatusForgot(true)} className='forgotPassword'>Забыли пароль или логин?</div>
                                        <div className="button_form1 skeleton-button" onClick={handlerButtonLogin}>
                                            {store.dataLang["enter_name"]}
                                        </div>
                                        <div className='forgotPassword'>Вход через соцсети</div>

                                        {/* <div className="dop">
                                            <div className="dot_length"></div>

                                        </div> */}
                                        <div className="social">
                                            <a className="google"
                                                href={NAME_SERVER + "/api/auth/google" + (room_id ? "?room=" + room_id : "")}><img
                                                    src={google} width={64} height={64} /></a>
                                            <a href={NAME_SERVER + "/api/auth/vk/"}><img src={vk} width={64}
                                                height={64} /></a>
                                            <a href={NAME_SERVER + "/api/auth/yandex/callback"}><img src={NAME_SERVER + "/assets/" + "icon_yandex.png"} width={64} height={64} /></a>

                                        </div>

                                    </form>
                                ) : (
                                    <form>
                                        <div style={{ position: "absolute", top: 0, left: 0 }}>
                                            <BackButton onClick={() => setStatusForgot(false)} />


                                        </div>
                                        {/* <h2>Введите почту</h2> */}


                                        <input className="login_input" type="text" onChange={e => setEmail(e.target.value)}
                                            placeholder={"Введите почту"} value={email} />
                                        <div className='forgotPassword' style={{ cursor: "default" }}>Проверьте папку спам, если не пришло сообщение</div>
                                        <div className="button_form1" onClick={async () => await handleRecover()} disabled={statusLoadRecoverBtn}>
                                            {statusLoadRecoverBtn ? <Spin /> : "Восстановить"}

                                        </div>
                                    </form>
                                )}



                            </div>


                        </div>

                    </>


                )}

           
        </>
    );
}

export default observer(LoginForm);